<template>
  <div class="filtro-previsto-realizado">
    <label>
      <input
        type="checkbox"
        value="previsto"
        :checked="value === 'previsto'"
        @change="onChange($event, 'previsto')"
      />
      Previsto
    </label>

    <label>
      <input
        type="checkbox"
        value="realizado"
        :checked="value === 'realizado'"
        @change="onChange($event, 'realizado')"
      />
      Realizado
      <span
        v-b-tooltip.html.hover
        title="Resultado quadrimestral liberado no SIAPS e importado no sistema."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'FiltroPrevistoRealizado',
  props: {
    value: {
      type: String,
      default: 'previsto',
    },
  },
  methods: {
    onChange(event, tipo) {
      this.$emit('input', event.target.checked ? tipo : 'previsto')
    },
  },
}
</script>

<style lang="scss" scoped>
.filtro-previsto-realizado {
  display: flex;
  gap: 16px;
  align-items: center;

  label {
    margin-bottom: 0;
  }
}
</style>
